<template>
    <div>
        <Checkbox
            :required="consent.required"
            :id="'inp-' + index"
            :name="consent.name"
            value="1"
            :checkedValue="isChecked(consent.name)"
            @input="updateInput($event)"
            @change="updateInput($event)"
            :text="consent.text"/>
        <Error :fieldName="consent.name" class="mb-2"/>
    </div>
</template>
<script>
import Checkbox from '../atoms/Checkbox'
import Error from '../atoms/Error'

export default {
    name: 'ConsentList',
    inject: ['$validator'],
    props: ['index', 'consent'],
    methods: {
        updateInput (e) {
            this.$emit('input', [e.target.name, e.target.checked])
        },
        isChecked (name) {
            return window.sessionStorage.getItem(name) === 'true' ? '1' : '0'
        }
    },
    components: {
        Checkbox,
        Error
    }
}
</script>
